module.exports = {
    RECEIVE_ALL_HYDROGEOLOGICAL_ENTITIES: 'RECEIVE_ALL_HYDROGEOLOGICAL_ENTITIES',
    RECEIVE_HYDROGEOLOGICAL_ENTITY: 'RECEIVE_HYDROGEOLOGICAL_ENTITY',
    RECEIVE_HYDROGEOLOGICAL_ENTITY_STRUCTURE: 'RECEIVE_HYDROGEOLOGICAL_ENTITY_STRUCTURE',
    RECEIVE_HYDROGEOLOGICAL_ENTITY_STATE: 'RECEIVE_HYDROGEOLOGICAL_ENTITY_STATE',
    RECEIVE_HYDROGEOLOGICAL_ENTITY_TYPE: 'RECEIVE_HYDROGEOLOGICAL_ENTITY_TYPE',
    RESET_HYDROGEOLOGICAL_ENTITY: 'RESET_HYDROGEOLOGICAL_ENTITY',
}